import React from "react";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import BoltIcon from "@mui/icons-material/Bolt";
import { useReactFlow } from "@xyflow/react";

export const NodeControls = ({
  nodeId,
  nodeStatus,
  onRun,
  onDisable,
  onDelete,
  onSettingsClick,
  onBottom,
}) => {
  const { setNodes } = useReactFlow();
  const theme = useTheme();
  const isLight = theme.palette.mode === "light";
  const isRunning = nodeStatus === "running";
  const buttons = [
    // Only show run button when not running
    ...(onRun && !isRunning
      ? [
          {
            label: "Run",
            icon: <BoltIcon />,
            handler: () => onRun(nodeId),
            disabled: false,
          },
        ]
      : []),
    ...(onDisable && !isRunning
      ? [{ label: "Disable", icon: <PowerSettingsNewIcon />, handler: () => onDisable(nodeId) }]
      : []),
    ...(!isRunning
      ? [
          {
            label: "Delete",
            icon: <DeleteIcon />,
            handler: () => {
              onDelete?.(nodeId);
              setNodes((nodes) => nodes.filter((n) => n.id !== nodeId));
            },
          },
        ]
      : []),
    ...(onSettingsClick && !isRunning
      ? [
          {
            label: "Settings",
            icon: <SettingsIcon />,
            handler: () => {
              console.log("Settings button clicked for nodeId:", nodeId);
              // Ensure we have a valid handler before calling
              if (typeof onSettingsClick === "function") {
                onSettingsClick(nodeId);
              } else {
                console.error("onSettingsClick is not a function:", onSettingsClick);
              }
            },
          },
        ]
      : []),
  ];
  const buttonStyle = {
    color: isLight ? "#333" : "#fff",
    background: "transparent",
    transition: "0.2s",
    "&:hover": {
      color: theme.palette.error.main,
    },
    "&:disabled": {
      color: isLight ? "#999" : "#666",
      cursor: "wait",
    },
  };

  return (
    <Box
      className="node-controls"
      sx={{
        position: "absolute",
        top: onBottom ? "auto" : -35,
        bottom: onBottom ? -38 : "auto",
        right: onBottom ? 15 : 0,
        display: "flex",
        width: "max-content",
        gap: 1,
        opacity: 0,
        transition: "opacity 0.2s",
        pointerEvents: "none",
        zIndex: 20,
      }}
    >
      <Box
        sx={{
          backgroundColor: isLight ? "#f5f5f5" : "#333333",
          borderRadius: "8px",
          marginBottom: "10px",
          boxShadow: isLight ? "0 1px 4px rgba(0,0,0,0.1)" : "0 2px 6px rgba(0,0,0,0.4)",
        }}
      >
        {buttons.map(({ label, icon, handler, disabled }) => (
          <Tooltip title={label} key={label}>
            <IconButton
              size="small"
              disableRipple
              disabled={disabled}
              onClick={(e) => {
                e.stopPropagation();
                handler?.();
              }}
              sx={buttonStyle}
            >
              {React.cloneElement(icon, { fontSize: "12px" })}
            </IconButton>
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
};
